import { createNativeStackNavigator } from '@react-navigation/native-stack';
import SplashScreen from 'src/presentation/screens/SplashScreen';
import BottomTabNavigator from 'src/presentation/navigation/navigators/BottomTabNavigator';
import EventScreen from 'src/presentation/screens/EventScreen';
import EventDeeplinkScreen from 'src/presentation/screens/EventDeeplinkScreen';
import ProgramHolderScreen from 'src/presentation/screens/ProgramHolderScreen';
import TimetableHolderScreen from 'src/presentation/screens/TimetableHolderScreen';
import TimetableScreen from 'src/presentation/screens/TimetableScreen';
import ProgramScreen from 'src/presentation/screens/ProgramScreen';
import CustomScreen from 'src/presentation/screens/CustomScreen';
import NewsItemScreen from 'src/presentation/screens/NewsItemScreen';
import MapScreen from 'src/presentation/screens/MapScreen';
import FormClosedScreen from 'src/presentation/screens/FormClosedScreen';
import FormLoginScreen from 'src/presentation/screens/FormLoginScreen';
import GalleryHolderScreen from 'src/presentation/screens/GalleryHolderScreen';
import GalleryScreen from 'src/presentation/screens/GalleryScreen';
import TimetableLayoutScreen from 'src/presentation/screens/TimetableLayoutScreen';
import NewsScreen from 'src/presentation/screens/NewsScreen';
import LocationsScreen from 'src/presentation/screens/LocationsScreen';
import FoodScreen from 'src/presentation/screens/FoodScreen';
import LoginScreen from 'src/presentation/screens/LoginScreen';
import LoginFormScreen from 'src/presentation/screens/LoginFormScreen';
import RegistrationFormScreen from 'src/presentation/screens/RegistrationFormScreen';
import ForgotPasswordScreen from 'src/presentation/screens/ForgotPasswordScreen';
import ChangePasswordScreen from 'src/presentation/screens/ChangePasswordScreen';
import QrScannerScreen from 'src/presentation/screens/QrScannerScreen';
import MySubmissionScreen from 'src/presentation/screens/MySubmissionScreen';
import Constants from 'src/core/utils/Constants';
import type { RootStackParamList } from 'src/presentation/navigation/types/NavigationTypes';

const Stack = createNativeStackNavigator<RootStackParamList>();

function RootNavigator() {
	return (
		<Stack.Navigator initialRouteName={Constants.screenIndex} screenOptions={{ headerShown: false, freezeOnBlur: true }}>
			<Stack.Screen component={SplashScreen} name={Constants.screenSplash} />
			<Stack.Screen component={BottomTabNavigator} name={Constants.screenIndex} />
			<Stack.Screen component={EventScreen} name={Constants.screenEvent} />
			<Stack.Screen component={EventDeeplinkScreen} name={Constants.screenEventDeeplink} />
			<Stack.Screen component={ProgramHolderScreen} name={Constants.screenProgramHolder} />
			<Stack.Screen component={TimetableHolderScreen} name={Constants.screenTimetableHolder} />
			<Stack.Screen component={TimetableScreen} name={Constants.screenTimetableDay} />
			<Stack.Screen component={ProgramScreen} name={Constants.screenProgram} />
			<Stack.Screen component={CustomScreen} name={Constants.screenProgramItem} />
			<Stack.Screen component={NewsItemScreen} name={Constants.screenNewsItemPage} />
			<Stack.Screen component={MapScreen} name={Constants.screenFloorplan} options={{ gestureEnabled: false }} />
			<Stack.Screen component={FormClosedScreen} name={Constants.screenFormClosed} />
			<Stack.Screen component={FormLoginScreen} name={Constants.screenFormLogin} />
			<Stack.Screen component={CustomScreen} name={Constants.screenCustom} />
			<Stack.Screen component={GalleryHolderScreen} name={Constants.screenGalleryHolder} />
			<Stack.Screen component={GalleryScreen} name={Constants.screenGallery} />
			<Stack.Screen component={CustomScreen} name={Constants.screenLocationItem} />
			<Stack.Screen component={CustomScreen} name={Constants.screenFoodItem} />
			<Stack.Screen component={CustomScreen} name={Constants.screenNewsItem} />
			<Stack.Screen component={TimetableLayoutScreen} name={Constants.screenTimeTablePage} />
			<Stack.Screen component={NewsScreen} name={Constants.screenNews} />
			<Stack.Screen component={LocationsScreen} name={Constants.screenLocations} />
			<Stack.Screen component={FoodScreen} name={Constants.screenFood} />
			<Stack.Screen component={LoginScreen} name={Constants.screenLogin} />
			<Stack.Screen component={LoginFormScreen} name={Constants.screenLoginForm} />
			<Stack.Screen component={RegistrationFormScreen} name={Constants.screenRegistrationForm} />
			<Stack.Screen component={ForgotPasswordScreen} name={Constants.screenForgotPassword} />
			<Stack.Screen component={ChangePasswordScreen} name={Constants.screenChangePassword} />
			<Stack.Screen component={QrScannerScreen} name={Constants.screenQrScanner} />
			<Stack.Screen component={MySubmissionScreen} name={Constants.screenMySubmission} />
		</Stack.Navigator>
	);
}

export default RootNavigator;
